import _regeneratorRuntime from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Indicator, IndicatorInput } from "../indicator/indicator";
import { SMA } from "../moving_averages/SMA";
import LinkedList from "../Utils/FixedSizeLinkedList";
/**
 * Created by AAravindan on 5/7/16.
 */

"use strict";

export var SDInput =
/*#__PURE__*/
function (_IndicatorInput) {
  _inherits(SDInput, _IndicatorInput);

  function SDInput() {
    _classCallCheck(this, SDInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(SDInput).apply(this, arguments));
  }

  return SDInput;
}(IndicatorInput);
export var SD =
/*#__PURE__*/
function (_Indicator) {
  _inherits(SD, _Indicator);

  function SD(input) {
    var _this;

    _classCallCheck(this, SD);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SD).call(this, input));
    var period = input.period;
    var priceArray = input.values;
    var sma = new SMA({
      period: period,
      values: [],
      format: function format(v) {
        return v;
      }
    });
    _this.result = [];
    _this.generator =
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var tick, mean, currentSet, sd, sum, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, x;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currentSet = new LinkedList(period);
              _context.next = 3;
              return;

            case 3:
              tick = _context.sent;

            case 4:
              if (!true) {
                _context.next = 34;
                break;
              }

              currentSet.push(tick);
              mean = sma.nextValue(tick);

              if (!mean) {
                _context.next = 29;
                break;
              }

              sum = 0;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 12;

              for (_iterator = currentSet.iterator()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                x = _step.value;
                sum = sum + Math.pow(x - mean, 2);
              }

              _context.next = 20;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](12);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 20:
              _context.prev = 20;
              _context.prev = 21;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 23:
              _context.prev = 23;

              if (!_didIteratorError) {
                _context.next = 26;
                break;
              }

              throw _iteratorError;

            case 26:
              return _context.finish(23);

            case 27:
              return _context.finish(20);

            case 28:
              sd = Math.sqrt(sum / period);

            case 29:
              _context.next = 31;
              return sd;

            case 31:
              tick = _context.sent;
              _context.next = 4;
              break;

            case 34:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[12, 16, 20, 28], [21,, 23, 27]]);
    })();

    _this.generator.next();

    priceArray.forEach(function (tick) {
      var result = _this.generator.next(tick);

      if (result.value !== undefined) {
        _this.result.push(_this.format(result.value));
      }
    });
    return _this;
  }

  _createClass(SD, [{
    key: "nextValue",
    value: function nextValue(price) {
      var nextResult = this.generator.next(price);

      if (nextResult.value !== undefined) {
        return this.format(nextResult.value);
      }
    }
  }]);

  return SD;
}(Indicator);
SD.calculate = sd;
export function sd(input) {
  Indicator.reverseInputs(input);
  var result = new SD(input).result;

  if (input.reversedInput) {
    result.reverse();
  }

  Indicator.reverseInputs(input);
  return result;
}